// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popupContainer {
    position: fixed;
    z-index: 31;
    top: 0;
    display: flex;
    margin: auto;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    justify-content: center;
}

html:has(.popupContainer) {
    overflow: hidden;
}

.popupContainer .popupAddFactor {
    width: 450px;
}

.uploadMediaPopup .mediaSearch .mediadate-dropdown .dateDropdown ul {
    max-height: 195px;
    overflow-y: auto;
}

.uploadMediaPopup .mediaSearch .mediadate-dropdown .dateDropdown {
    min-width: 170px;
}

.textBlock {
    position: relative;
    top: 0;
    margin-top: 28px;
}

.popupBlock-wrapper::-webkit-scrollbar-thumb,
.uploadMediaPopup .grid-container::-webkit-scrollbar-thumb,
.uploadMediaPopup .file-wrapper .file::-webkit-scrollbar-thumb {
    border-radius: 6px;
    padding: 5px;
    background-color: var(--lightgrey);
}

.popupBlock-wrapper::-webkit-scrollbar-thumb:hover,
.uploadMediaPopup .grid-container::-webkit-scrollbar-thumb:hover,
.uploadMediaPopup .file-wrapper .file::-webkit-scrollbar-thumb:hover {
    background-color: #f2f2f2;
}

.popupBlock-wrapper::-webkit-scrollbar-track,
.uploadMediaPopup .grid-container::-webkit-scrollbar-track,
.uploadMediaPopup .file-wrapper .file::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #f9fafc;
}

.popupBlock-wrapper::-webkit-scrollbar,
.uploadMediaPopup .grid-container::-webkit-scrollbar,
.uploadMediaPopup .file-wrapper .file::-webkit-scrollbar {
    height: 5px;
    background-color: #f9fafc;
    width: 6px;
}

.uploadMediaPopup .popupBlock {
    width: calc(100dvw - 60px);
    max-width: calc(100dvw - 60px);
    height: calc(100dvh - 50px);
    background-color: #fff;
    z-index: 99;
    margin:auto;
}

.uploadMediaPopup .deleteIconImage {
    top: 0;
    cursor: pointer;
}

.uploadMediaPopup .mediaSearch {
    margin-bottom: 24px;
}

.uploadMediaPopup .grid-container {
    width: 100%;
    display: inline-block;
    vertical-align: top;
    padding: 24px;
    border: none;
    border-radius: 0;
    margin-top: 0;
    overflow-y: auto;
    overflow-x: hidden;
    max-height: calc(100dvh - 130px);
}

.uploadMediaPopup .grid-container.show-wrapper {
    width: 70%;
}

.uploadMediaPopupOverflow {
    overflow: hidden;
}

.uploadMediaPopup .mediaSearchTop .mediaSearchInput input {
    border-color: var(--lightgrey);
    background-color: var(--white);
}

.uploadMediaPopup .file-wrapper .file {
    padding: 24px;
    overflow-y: auto;
    max-height: calc(100dvh - 226px);
}

.uploadMediaPopup .file-wrapper {
    background-color: var(--frostedwhite);
    position: relative;
    display: inline-block;
    width: 30%;
    vertical-align: top;
    left: 30%;
    border-left: 1px solid var(--lightgrey);
}

.uploadMediaPopup .file-wrapper.show-wrapper {
    left: 0;
    position: sticky;
    bottom: -1px;
}

.uploadMediaPopup .mediasSearchIcon {
    position: relative;
    z-index: 1;
}

.uploadMediaPopup .popupBlock .popupBlock-wrapper {
    display: block;
    padding: 0;
    height: 100%;
}

.uploadMediaPopup .popupBlock .popupBlock-wrapper .popupBlock-inner .poppContentWrapper {
    display: block;
    height: 100%;
    max-height: calc(100dvh - 140px);
}

.uploadMediaPopup .tabTitle {
    display: flex;
    align-items: center;
    margin: 5px 0 0;
    border-bottom: 1px solid var(--lightgrey);
    padding: 0 24px;
}

.uploadMediaPopup .popupBlock .popupContent .popupTitle {
    padding: 10px 24px 0;
    margin-top: 0;
    font-weight: 600;
    font-size: 18px;
    color: var(--darkblue);
    line-height: 20px;
    margin-bottom: 15px;
}

.uploadMediaPopup .tabTitle li:after {
    content: "";
    position: absolute;
    width: 0;
    height: 2px;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: var(--charcoalblue);
    margin: 0 auto;
    transition: all 0.2s linear;
}

.uploadMediaPopup .tabTitle li.active:after {
    width: 100%;
}

.uploadMediaPopup .popupBlock .popupContent {
    margin-bottom: 0;
}

.uploadMediaPopup .tabTitle li {
    cursor: pointer;
    padding-bottom: 10px;
    position: relative;
    color: var(--fiord);
    font-size: 14px;
    font-weight: 500;
}

.uploadMediaPopup .fileUploadBox .uploadFileBlock {
    height: calc(100dvh - 188px);
    padding: 15px;
    width: calc(100% - 48px);
    margin: 0 auto;
}

.uploadMediaPopup .uploadFileBlock .newPageImageUploadText {
    text-align: center;
    line-height: 20px;
    margin-top: 0;
}

.uploadMediaPopupCloseIcon {
    top: 18px !important;
    right: 20px !important;
}

.uploadMediaPopup .tabTitle li.active {
    color: var(--charcoalblue);
    font-weight: 600;
}

.uploadMediaPopup .tabTitle li:not(:last-child) {
    margin-right: 20px;
    font-weight: 600;
}

.uploadMediaPopup .show-wrapper .video-box-group {
    margin-top: 0;
}

.uploadMediaPopup .show-wrapper .video-box-group .skeleton-video-wrapper {
    margin-top: 0;
}

.mediapopupBlock {
    border-radius: 6px !important;
}

.mediapopupBlock .modalInput {
    box-shadow: none;
}

.mediapopupBlock .modalActions {
    margin: 0 24px;
}

.mediapopupBlock .modalActions {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    gap: 20px;
}

.popupBlock-wrapper {
    display: flex;
    padding: 20px;
    column-gap: 30px;
    overflow-y: auto;
    max-height: calc(100dvh - 40px);
    margin: 5px;
}

.popupBlock-wrapper .background_icon {
    background-position: 10px 10.5px !important;
    background-repeat: no-repeat !important;
    background-size: 20px !important;
    padding-left: 40px !important;
}

.uploadMediaPopupOverflow {
    overflow: hidden;
}

.popupBlockPlan:has(.popupChange) .popupBlock-inner,
.popupBlockPlan .popupChange {
    width: 50%;
}

.uploadMediaPopup .popupBlock .popupBlock-wrapper .popupBlock-inner {
    height: 100%;
}

.newpageLeftRow .uploadFileBlock .progress {
    border-radius: 99px;
    background: var(--lightgrey);
    border: none;
    height: 6px;
    left: 0;
    transform: none;
    right: 0;
    margin: 0;
    position: relative;
    width: 100%;
    top: 0;
}

.newpageLeftRow .uploadFileBlock .progress .color {
    height: 6px;
    background-color: var(--bg-green);
}

.ulpoadImageBlock.uploadRunning {
    -webkit-user-select: none;
            user-select: none;
}

.uploadRunning .uploadItem.uploadingQueue {
    pointer-events: none;
    -webkit-user-select: unset;
            user-select: unset;
}

.newpageImageUpload.draging {
    border-color: var(--bg-green);
}

.draging:before {
    content: "";
    position: absolute;
    width: 100%;
}

.draging {
    opacity: 0.6;
}

.fileUploadBox.draging .uploadFileBlock,
.mediaGallery .fileUploadBox.draging .uploadFileBlock {
    border-color: var(--bg-green);
}

.fileUploadBox .fileUploadedCover {
    text-align: center;
}

.fileUploadBox .fileUploadCover_Img {
    margin: 0 auto;
    background: var(--mistygray);
    border: 6px solid var(--ghostwhite);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    height: 40px;
    width: 40px;
    padding: 5px !important;
    margin-bottom: 5px;
}

.fileUploadBox .fileUploadedCover_wrapp {
    margin: 0 auto;
    background: var(--mistygray);
    border: 6px solid var(--ghostwhite);
    display: inline-block;
    padding: 10px;
    border-radius: 50%;
    width: 53px;
    height: 53px;
    line-height: 28px;
    margin-bottom: 10px;
}

.fileUploadBox .fileUploadedCover p {
    color: var(--grayishblue);
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    margin: 0;
}

.fileUploadBox .fileUploadedCover .uploaded-file-name {
    margin-bottom: 6px;
}

.fileUploadBox .uploadFileBlock {
    max-width: 100%;
    min-height: 206px;
}

.newpageImageUpload .featureImg-loader,
.uploadFileBlock .featureImg-loader {
    padding-top: 0;
    height: 200px;
}

.newpageImageUpload .progress,
.uploadFileBlock .progress {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.uploadFileBlock .newPageImageUploadText {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: var(--grayishblue);
    -webkit-user-select: none;
            user-select: none;
    text-align: center;
    padding-top: 10px;
}

.uploadFileBlock .uploadFileBlockDetails {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    text-align: center;
    margin: 0 auto;
}

.uploadFileBlock {
    background: var(--white);
    border: 1px solid var(--lightgrey);
    border-radius: 6px;
    box-shadow: var(--boxshadow);
    min-height: 215px;
    max-width: 384px;
    position: relative;
    z-index: 0;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
}

.uploadFileBlock.preloadFile {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    text-align: center;
}

.uploadFileBlock label {
    border: none;
    background: transparent;
    box-shadow: var(--boxshadow);
    border-radius: 8px;
    width: 100%;
    max-width: unset;
    z-index: 99;
}

.fileUploadCover_Img {
    margin: 0 auto;
    display: block;
}

.newPageImageUploadText {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: var(--grayishblue);
    -webkit-user-select: none;
            user-select: none;
    text-align: center;
    padding-top: 10px;
}

.newPageImageUploadText span {
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: var(--eerieblack);
}


/* -----------UploadedPopup media -------------- */
.grid-container {
    max-width: 100%;
    border: 1px solid var(--lightgrey);
    padding: 20px;
    margin-top: 25px;
    border-radius: 6px;
    position: relative;
}

.media-grid-layout .gridImg:has(input[type="checkbox"]:checked) {
    border-color: var(--eerieblack);
}

.media-grid-layout .NoResults {
    border-top: none;
}


.media-grid-layout .progress-wrap {
    top: 50%;
    position: absolute;
    transform: translateY(-50%);
    width: 100%;
    margin: 0 auto;
}

.media-grid-layout .progress-wrap .progress {
    top: -2px;
    left: unset;
    margin: 0 auto;
    text-align: center;
}

.media-grid-layout .uploadPicture {
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
}

.media-grid-layout .gridImg {
    position: relative;
    cursor: pointer;
    overflow: hidden;
    border: 1px solid #e5e7eb;
}

.media-grid-layout:not(:has(.uploadPicture)) .gridImg:before,
.media-grid-layout .gridImg:before {
    content: "";
    display: block;
    padding-top: 100%;
}

.media-grid-layout input[type="checkbox"] {
    position: absolute;
    top: 10px;
    right: 10px;
    border-radius: 4px;
    appearance: none;
    box-shadow: none;
}

.media-grid-layout input[type="checkbox"]::before {
    margin-right: 0;
    background-color: var(--white);
}

.media-grid-layout input[type="checkbox"]:not(:checked)::before {
    background-color: var(--white);
}

.media-grid-layout .list-search input[type="checkbox"] {
    font-size: 0;
    width: 18px;
    height: 18px;
    border: 1px solid transparent;
    -o-appearance: none;
    appearance: none;
    position: relative;
    padding: 0 0 0 0;
    margin: 0;
    margin-right: 9px !important;
    right: 0;
    top: 0;
    box-shadow: none;
}

.mediaSearch {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.mediaSearchTop {
    display: flex;
    flex-direction: row;
    gap: 10px;
    flex-wrap: wrap;
}

.mediaSearchTop .mediaSearchInput {
    width: 400px;
    position: relative;
}

.mediaSearchTop .mediaSearchInput img.mediaSearchIcon {
    left: 15px;
    max-width: 14px;
    position: absolute;
    top: 14px;
}

.mediaSearchTop .mediaSearchInput input {
    width: calc(100% - 5px);
    height: 42px !important;
    background: var(--white);
    border: 1px solid var(--ashyblue);
    border-radius: 6px;
    padding: 5px 5px 6px 40px;
    outline: none;
    right: 15px;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: var(--darkblue);
}

.mediaSearchTop .mediaSearchInput input:not([type="checkbox"]) {
    height: 42px !important;
}

.mediaSearchTop .mediaSearchInput img {
    left: 15px;
    max-width: 14px;
    position: absolute;
    top: 14px;
}

.customLinkRow input::placeholder,
.mediaSearchTop .mediaSearchInput input::placeholder {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: var(--grey);
}

.gridIitem .itemName {
    position: absolute;
    width: 100%;
    bottom: 0;
    padding: 10px;
    border-top: 1px solid var(--lightgrey);
    text-align: center;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    background-color: var(--frostedwhite);
    color: var(--fiord);
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
}

.gridIitem {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(175px, 1fr));
    gap: 24px;
}

.gridImg {
    max-width: 100%;
    border: 1px solid var(--lightgrey);
    border-radius: 4px;
    margin-bottom: 0;
    line-height: 1;
}

.gridImg.preview-acive {
    border-color: var(--eerieblack);
}

.gridImg .item {
    height: 100%;
    width: 100%;
    object-fit: cover;
    border-radius: inherit;
    overflow: hidden;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
}

.gridImg.type-doc .item {
    object-fit: none;
    max-height: calc(100% - 37px);
    background-color: var(--frostedwhite);
}

@media screen and (max-width: 1500px) {
    .mediaSearch {
        align-items: flex-start;
    }
}

@media screen and (max-width: 1200px) {
    .uploadMediaPopup .deleteIconImage {
        top: 10px;
    }

    .gridIitem {
        grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
        gap: 20px;
    }
}

@media screen and (max-width: 991px) {
    .popupContainer .popupAddFactor {
        width: calc(100% - 30px);
    }

    .uploadMediaPopup .popup-overlay {
        background-color: rgba(255, 255, 255, 1);
    }

    .uploadMediaPopup .grid-container.show-wrapper .register-wrapp .register-right {
        display: none;
    }

    .uploadMediaPopup .grid-container.show-wrapper {
        width: 100%;
    }

    .uploadMediaPopup .popupBlock {
        width: calc(100dvw - 30px);
        max-width: calc(100dvw - 30px);
    }

    .uploadMediaPopup .grid-container {
        width: 100%;
        display: block;
        padding: 24px;
        max-height: calc(100dvh - 216px);
    }

    .uploadMediaPopup .file-wrapper {
        width: 100%;
        border-left: none;
        border-top: 1px solid var(--lightgrey);
        height: auto;
        min-height: unset;
    }

    .uploadMediaPopup .file-wrapper .file {
        display: none;
    }

    .uploadMediaPopup .file-wrapper .modalActions {
        display: none;
    }

    .uploadMediaPopup .popupBlock .popupBlock-wrapper .popupBlock-inner {
        height: auto;
        border: 1px solid var(--lightgrey);
        border-radius: 8px;
    }

    .uploadMediaPopup .fileUploadBox .uploadFileBlock {
        width: 100%;
        border: none;
        box-shadow: none;
        height: calc(100dvh - 175px);
    }

    .popupBlock-wrapper {
        padding: 15px;
        margin: 5px;
    }

    .popupBlockPlan:has(.popupChange) .popupBlock-inner,
    .popupBlockPlan .popupChange {
        width: 100%;
    }
}

@media screen and (max-width: 980px) {
    .mediaSearchTop .mediaSearchInput input {
        right: 0px;
        width: calc(100% - 20px);
    }

    .mediaSearchTop .mediaSearchInput img {
        position: absolute;
        left: 15px;
        top: 13px;
    }
}

@media screen and (max-width: 840px) {
    .mediaSearch {
        margin-top: 0px;
    }

    .mediaSearchTop .mediaSearchInput input {
        right: 0px;
    }

    .mediaSearchTop .mediaSearchInput img {
        left: 15px;
    }
}

@media screen and (max-width: 768px) {
    .mediaSearch {
        display: flex;
    }

    .mediaSearchTop .mediaSearchInput{
        width: calc(100% - 50px);
    }

    .mediaSearchTop .mediaSearchInput input {
        right: 0px;
    }

    .mediaSearchTop .mediaSearchInput img {
        left: 15px;
    }

    .gridIitem {
        grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
    }
}

@media screen and (max-width: 767px) {
    .uploadMediaPopup .popupBlock .popupContent .popupTitle {
        padding: 15px 15px 0;
    }

    .uploadMediaPopup .tabTitle {
        padding: 0 15px;
    }

    .uploadMediaPopup .grid-container {
        padding: 15px;
        height: auto;
    }

    .uploadMediaPopup .fileUploadBox .uploadFileBlock {
        height: auto;
        min-height: 361px;
    }

    .uploadMediaPopup .mediaSearch {
        margin-bottom: 15px;
    }

    .uploadMediaPopup .file-wrapper {
        border-top: none;
    }
}

@media screen and (max-width: 576px) {
    .gridIitem {
        grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
    }
}

@media screen and (max-width: 490px) {
    .fileUploadCover_Img {
        padding-top: 0 !important;
    }
}

@media screen and (max-width: 480px) {
    .mediaSearch {
        width: 100%;
    }
}

@media screen and (max-width: 400px) {
    .popupBlock-wrapper {
        padding: 10px;
    }
}

@media screen and (max-width: 390px) {
    .fileUploadCover_Img {
        padding-top: 15px;
    }
}

@media screen and (max-width: 360px) {
    .gridIitem {
        grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/mediapopup.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,WAAW;IACX,MAAM;IACN,aAAa;IACb,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,gBAAgB;AACpB;;AAEA;;;IAGI,kBAAkB;IAClB,YAAY;IACZ,kCAAkC;AACtC;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;;;IAGI,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;;;IAGI,WAAW;IACX,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,0BAA0B;IAC1B,8BAA8B;IAC9B,2BAA2B;IAC3B,sBAAsB;IACtB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,MAAM;IACN,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;IACV,mBAAmB;IACnB,SAAS;IACT,uCAAuC;AAC3C;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,cAAc;IACd,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,yCAAyC;IACzC,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,SAAS;IACT,OAAO;IACP,QAAQ;IACR,qCAAqC;IACrC,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,aAAa;IACb,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,+BAA+B;IAC/B,WAAW;AACf;;AAEA;IACI,2CAA2C;IAC3C,uCAAuC;IACvC,gCAAgC;IAChC,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,4BAA4B;IAC5B,YAAY;IACZ,WAAW;IACX,OAAO;IACP,eAAe;IACf,QAAQ;IACR,SAAS;IACT,kBAAkB;IAClB,WAAW;IACX,MAAM;AACV;;AAEA;IACI,WAAW;IACX,iCAAiC;AACrC;;AAEA;IACI,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,0BAAkB;YAAlB,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,4BAA4B;IAC5B,mCAAmC;IACnC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,4BAA4B;IAC5B,mCAAmC;IACnC,qBAAqB;IACrB,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;;IAEI,cAAc;IACd,aAAa;AACjB;;AAEA;;IAEI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,yBAAiB;YAAjB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,kCAAkC;IAClC,kBAAkB;IAClB,4BAA4B;IAC5B,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,4BAA4B;IAC5B,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,yBAAiB;YAAjB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,wBAAwB;AAC5B;;;AAGA,kDAAkD;AAClD;IACI,eAAe;IACf,kCAAkC;IAClC,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;AACpB;;;AAGA;IACI,QAAQ;IACR,kBAAkB;IAClB,2BAA2B;IAC3B,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,OAAO;IACP,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;;IAEI,WAAW;IACX,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,6BAA6B;IAG7B,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,4BAA4B;IAC5B,QAAQ;IACR,MAAM;IACN,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,wBAAwB;IACxB,iCAAiC;IACjC,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,SAAS;AACb;;AAEA;;IAEI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,aAAa;IACb,sCAAsC;IACtC,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,qCAAqC;IACrC,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,eAAe;IACf,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,qCAAqC;AACzC;;AAEA;IACI;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,SAAS;IACb;;IAEA;QACI,2DAA2D;QAC3D,SAAS;IACb;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,wCAAwC;IAC5C;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,0BAA0B;QAC1B,8BAA8B;IAClC;;IAEA;QACI,WAAW;QACX,cAAc;QACd,aAAa;QACb,gCAAgC;IACpC;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB,sCAAsC;QACtC,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,kCAAkC;QAClC,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,4BAA4B;IAChC;;IAEA;QACI,aAAa;QACb,WAAW;IACf;;IAEA;;QAEI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,UAAU;QACV,wBAAwB;IAC5B;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,SAAS;IACb;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,2DAA2D;IAC/D;AACJ;;AAEA;IACI;QACI,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,2DAA2D;IAC/D;AACJ;;AAEA;IACI;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,2DAA2D;IAC/D;AACJ","sourcesContent":[".popupContainer {\n    position: fixed;\n    z-index: 31;\n    top: 0;\n    display: flex;\n    margin: auto;\n    left: 0;\n    right: 0;\n    width: 100%;\n    height: 100%;\n    justify-content: center;\n}\n\nhtml:has(.popupContainer) {\n    overflow: hidden;\n}\n\n.popupContainer .popupAddFactor {\n    width: 450px;\n}\n\n.uploadMediaPopup .mediaSearch .mediadate-dropdown .dateDropdown ul {\n    max-height: 195px;\n    overflow-y: auto;\n}\n\n.uploadMediaPopup .mediaSearch .mediadate-dropdown .dateDropdown {\n    min-width: 170px;\n}\n\n.textBlock {\n    position: relative;\n    top: 0;\n    margin-top: 28px;\n}\n\n.popupBlock-wrapper::-webkit-scrollbar-thumb,\n.uploadMediaPopup .grid-container::-webkit-scrollbar-thumb,\n.uploadMediaPopup .file-wrapper .file::-webkit-scrollbar-thumb {\n    border-radius: 6px;\n    padding: 5px;\n    background-color: var(--lightgrey);\n}\n\n.popupBlock-wrapper::-webkit-scrollbar-thumb:hover,\n.uploadMediaPopup .grid-container::-webkit-scrollbar-thumb:hover,\n.uploadMediaPopup .file-wrapper .file::-webkit-scrollbar-thumb:hover {\n    background-color: #f2f2f2;\n}\n\n.popupBlock-wrapper::-webkit-scrollbar-track,\n.uploadMediaPopup .grid-container::-webkit-scrollbar-track,\n.uploadMediaPopup .file-wrapper .file::-webkit-scrollbar-track {\n    border-radius: 5px;\n    background-color: #f9fafc;\n}\n\n.popupBlock-wrapper::-webkit-scrollbar,\n.uploadMediaPopup .grid-container::-webkit-scrollbar,\n.uploadMediaPopup .file-wrapper .file::-webkit-scrollbar {\n    height: 5px;\n    background-color: #f9fafc;\n    width: 6px;\n}\n\n.uploadMediaPopup .popupBlock {\n    width: calc(100dvw - 60px);\n    max-width: calc(100dvw - 60px);\n    height: calc(100dvh - 50px);\n    background-color: #fff;\n    z-index: 99;\n    margin:auto;\n}\n\n.uploadMediaPopup .deleteIconImage {\n    top: 0;\n    cursor: pointer;\n}\n\n.uploadMediaPopup .mediaSearch {\n    margin-bottom: 24px;\n}\n\n.uploadMediaPopup .grid-container {\n    width: 100%;\n    display: inline-block;\n    vertical-align: top;\n    padding: 24px;\n    border: none;\n    border-radius: 0;\n    margin-top: 0;\n    overflow-y: auto;\n    overflow-x: hidden;\n    max-height: calc(100dvh - 130px);\n}\n\n.uploadMediaPopup .grid-container.show-wrapper {\n    width: 70%;\n}\n\n.uploadMediaPopupOverflow {\n    overflow: hidden;\n}\n\n.uploadMediaPopup .mediaSearchTop .mediaSearchInput input {\n    border-color: var(--lightgrey);\n    background-color: var(--white);\n}\n\n.uploadMediaPopup .file-wrapper .file {\n    padding: 24px;\n    overflow-y: auto;\n    max-height: calc(100dvh - 226px);\n}\n\n.uploadMediaPopup .file-wrapper {\n    background-color: var(--frostedwhite);\n    position: relative;\n    display: inline-block;\n    width: 30%;\n    vertical-align: top;\n    left: 30%;\n    border-left: 1px solid var(--lightgrey);\n}\n\n.uploadMediaPopup .file-wrapper.show-wrapper {\n    left: 0;\n    position: sticky;\n    bottom: -1px;\n}\n\n.uploadMediaPopup .mediasSearchIcon {\n    position: relative;\n    z-index: 1;\n}\n\n.uploadMediaPopup .popupBlock .popupBlock-wrapper {\n    display: block;\n    padding: 0;\n    height: 100%;\n}\n\n.uploadMediaPopup .popupBlock .popupBlock-wrapper .popupBlock-inner .poppContentWrapper {\n    display: block;\n    height: 100%;\n    max-height: calc(100dvh - 140px);\n}\n\n.uploadMediaPopup .tabTitle {\n    display: flex;\n    align-items: center;\n    margin: 5px 0 0;\n    border-bottom: 1px solid var(--lightgrey);\n    padding: 0 24px;\n}\n\n.uploadMediaPopup .popupBlock .popupContent .popupTitle {\n    padding: 10px 24px 0;\n    margin-top: 0;\n    font-weight: 600;\n    font-size: 18px;\n    color: var(--darkblue);\n    line-height: 20px;\n    margin-bottom: 15px;\n}\n\n.uploadMediaPopup .tabTitle li:after {\n    content: \"\";\n    position: absolute;\n    width: 0;\n    height: 2px;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background-color: var(--charcoalblue);\n    margin: 0 auto;\n    transition: all 0.2s linear;\n}\n\n.uploadMediaPopup .tabTitle li.active:after {\n    width: 100%;\n}\n\n.uploadMediaPopup .popupBlock .popupContent {\n    margin-bottom: 0;\n}\n\n.uploadMediaPopup .tabTitle li {\n    cursor: pointer;\n    padding-bottom: 10px;\n    position: relative;\n    color: var(--fiord);\n    font-size: 14px;\n    font-weight: 500;\n}\n\n.uploadMediaPopup .fileUploadBox .uploadFileBlock {\n    height: calc(100dvh - 188px);\n    padding: 15px;\n    width: calc(100% - 48px);\n    margin: 0 auto;\n}\n\n.uploadMediaPopup .uploadFileBlock .newPageImageUploadText {\n    text-align: center;\n    line-height: 20px;\n    margin-top: 0;\n}\n\n.uploadMediaPopupCloseIcon {\n    top: 18px !important;\n    right: 20px !important;\n}\n\n.uploadMediaPopup .tabTitle li.active {\n    color: var(--charcoalblue);\n    font-weight: 600;\n}\n\n.uploadMediaPopup .tabTitle li:not(:last-child) {\n    margin-right: 20px;\n    font-weight: 600;\n}\n\n.uploadMediaPopup .show-wrapper .video-box-group {\n    margin-top: 0;\n}\n\n.uploadMediaPopup .show-wrapper .video-box-group .skeleton-video-wrapper {\n    margin-top: 0;\n}\n\n.mediapopupBlock {\n    border-radius: 6px !important;\n}\n\n.mediapopupBlock .modalInput {\n    box-shadow: none;\n}\n\n.mediapopupBlock .modalActions {\n    margin: 0 24px;\n}\n\n.mediapopupBlock .modalActions {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 20px;\n    gap: 20px;\n}\n\n.popupBlock-wrapper {\n    display: flex;\n    padding: 20px;\n    column-gap: 30px;\n    overflow-y: auto;\n    max-height: calc(100dvh - 40px);\n    margin: 5px;\n}\n\n.popupBlock-wrapper .background_icon {\n    background-position: 10px 10.5px !important;\n    background-repeat: no-repeat !important;\n    background-size: 20px !important;\n    padding-left: 40px !important;\n}\n\n.uploadMediaPopupOverflow {\n    overflow: hidden;\n}\n\n.popupBlockPlan:has(.popupChange) .popupBlock-inner,\n.popupBlockPlan .popupChange {\n    width: 50%;\n}\n\n.uploadMediaPopup .popupBlock .popupBlock-wrapper .popupBlock-inner {\n    height: 100%;\n}\n\n.newpageLeftRow .uploadFileBlock .progress {\n    border-radius: 99px;\n    background: var(--lightgrey);\n    border: none;\n    height: 6px;\n    left: 0;\n    transform: none;\n    right: 0;\n    margin: 0;\n    position: relative;\n    width: 100%;\n    top: 0;\n}\n\n.newpageLeftRow .uploadFileBlock .progress .color {\n    height: 6px;\n    background-color: var(--bg-green);\n}\n\n.ulpoadImageBlock.uploadRunning {\n    user-select: none;\n}\n\n.uploadRunning .uploadItem.uploadingQueue {\n    pointer-events: none;\n    user-select: unset;\n}\n\n.newpageImageUpload.draging {\n    border-color: var(--bg-green);\n}\n\n.draging:before {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n}\n\n.draging {\n    opacity: 0.6;\n}\n\n.fileUploadBox.draging .uploadFileBlock,\n.mediaGallery .fileUploadBox.draging .uploadFileBlock {\n    border-color: var(--bg-green);\n}\n\n.fileUploadBox .fileUploadedCover {\n    text-align: center;\n}\n\n.fileUploadBox .fileUploadCover_Img {\n    margin: 0 auto;\n    background: var(--mistygray);\n    border: 6px solid var(--ghostwhite);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 50%;\n    height: 40px;\n    width: 40px;\n    padding: 5px !important;\n    margin-bottom: 5px;\n}\n\n.fileUploadBox .fileUploadedCover_wrapp {\n    margin: 0 auto;\n    background: var(--mistygray);\n    border: 6px solid var(--ghostwhite);\n    display: inline-block;\n    padding: 10px;\n    border-radius: 50%;\n    width: 53px;\n    height: 53px;\n    line-height: 28px;\n    margin-bottom: 10px;\n}\n\n.fileUploadBox .fileUploadedCover p {\n    color: var(--grayishblue);\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 20px;\n    margin: 0;\n}\n\n.fileUploadBox .fileUploadedCover .uploaded-file-name {\n    margin-bottom: 6px;\n}\n\n.fileUploadBox .uploadFileBlock {\n    max-width: 100%;\n    min-height: 206px;\n}\n\n.newpageImageUpload .featureImg-loader,\n.uploadFileBlock .featureImg-loader {\n    padding-top: 0;\n    height: 200px;\n}\n\n.newpageImageUpload .progress,\n.uploadFileBlock .progress {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.uploadFileBlock .newPageImageUploadText {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n    color: var(--grayishblue);\n    user-select: none;\n    text-align: center;\n    padding-top: 10px;\n}\n\n.uploadFileBlock .uploadFileBlockDetails {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    text-align: center;\n    margin: 0 auto;\n}\n\n.uploadFileBlock {\n    background: var(--white);\n    border: 1px solid var(--lightgrey);\n    border-radius: 6px;\n    box-shadow: var(--boxshadow);\n    min-height: 215px;\n    max-width: 384px;\n    position: relative;\n    z-index: 0;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.uploadFileBlock.preloadFile {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    text-align: center;\n}\n\n.uploadFileBlock label {\n    border: none;\n    background: transparent;\n    box-shadow: var(--boxshadow);\n    border-radius: 8px;\n    width: 100%;\n    max-width: unset;\n    z-index: 99;\n}\n\n.fileUploadCover_Img {\n    margin: 0 auto;\n    display: block;\n}\n\n.newPageImageUploadText {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n    color: var(--grayishblue);\n    user-select: none;\n    text-align: center;\n    padding-top: 10px;\n}\n\n.newPageImageUploadText span {\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 20px;\n    color: var(--eerieblack);\n}\n\n\n/* -----------UploadedPopup media -------------- */\n.grid-container {\n    max-width: 100%;\n    border: 1px solid var(--lightgrey);\n    padding: 20px;\n    margin-top: 25px;\n    border-radius: 6px;\n    position: relative;\n}\n\n.media-grid-layout .gridImg:has(input[type=\"checkbox\"]:checked) {\n    border-color: var(--eerieblack);\n}\n\n.media-grid-layout .NoResults {\n    border-top: none;\n}\n\n\n.media-grid-layout .progress-wrap {\n    top: 50%;\n    position: absolute;\n    transform: translateY(-50%);\n    width: 100%;\n    margin: 0 auto;\n}\n\n.media-grid-layout .progress-wrap .progress {\n    top: -2px;\n    left: unset;\n    margin: 0 auto;\n    text-align: center;\n}\n\n.media-grid-layout .uploadPicture {\n    height: 100%;\n    position: absolute;\n    top: 0;\n    right: 0;\n    left: 0;\n    bottom: 0;\n}\n\n.media-grid-layout .gridImg {\n    position: relative;\n    cursor: pointer;\n    overflow: hidden;\n    border: 1px solid #e5e7eb;\n}\n\n.media-grid-layout:not(:has(.uploadPicture)) .gridImg:before,\n.media-grid-layout .gridImg:before {\n    content: \"\";\n    display: block;\n    padding-top: 100%;\n}\n\n.media-grid-layout input[type=\"checkbox\"] {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    border-radius: 4px;\n    appearance: none;\n    box-shadow: none;\n}\n\n.media-grid-layout input[type=\"checkbox\"]::before {\n    margin-right: 0;\n    background-color: var(--white);\n}\n\n.media-grid-layout input[type=\"checkbox\"]:not(:checked)::before {\n    background-color: var(--white);\n}\n\n.media-grid-layout .list-search input[type=\"checkbox\"] {\n    font-size: 0;\n    width: 18px;\n    height: 18px;\n    border: 1px solid transparent;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n    -o-appearance: none;\n    appearance: none;\n    position: relative;\n    padding: 0 0 0 0;\n    margin: 0;\n    margin-right: 9px !important;\n    right: 0;\n    top: 0;\n    box-shadow: none;\n}\n\n.mediaSearch {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.mediaSearchTop {\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.mediaSearchTop .mediaSearchInput {\n    width: 400px;\n    position: relative;\n}\n\n.mediaSearchTop .mediaSearchInput img.mediaSearchIcon {\n    left: 15px;\n    max-width: 14px;\n    position: absolute;\n    top: 14px;\n}\n\n.mediaSearchTop .mediaSearchInput input {\n    width: calc(100% - 5px);\n    height: 42px !important;\n    background: var(--white);\n    border: 1px solid var(--ashyblue);\n    border-radius: 6px;\n    padding: 5px 5px 6px 40px;\n    outline: none;\n    right: 15px;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n    color: var(--darkblue);\n}\n\n.mediaSearchTop .mediaSearchInput input:not([type=\"checkbox\"]) {\n    height: 42px !important;\n}\n\n.mediaSearchTop .mediaSearchInput img {\n    left: 15px;\n    max-width: 14px;\n    position: absolute;\n    top: 14px;\n}\n\n.customLinkRow input::placeholder,\n.mediaSearchTop .mediaSearchInput input::placeholder {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n    color: var(--grey);\n}\n\n.gridIitem .itemName {\n    position: absolute;\n    width: 100%;\n    bottom: 0;\n    padding: 10px;\n    border-top: 1px solid var(--lightgrey);\n    text-align: center;\n    -webkit-line-clamp: 1;\n    line-clamp: 1;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n    background-color: var(--frostedwhite);\n    color: var(--fiord);\n    font-size: 14px;\n    line-height: 20px;\n    font-weight: 500;\n}\n\n.gridIitem {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(175px, 1fr));\n    gap: 24px;\n}\n\n.gridImg {\n    max-width: 100%;\n    border: 1px solid var(--lightgrey);\n    border-radius: 4px;\n    margin-bottom: 0;\n    line-height: 1;\n}\n\n.gridImg.preview-acive {\n    border-color: var(--eerieblack);\n}\n\n.gridImg .item {\n    height: 100%;\n    width: 100%;\n    object-fit: cover;\n    border-radius: inherit;\n    overflow: hidden;\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n}\n\n.gridImg.type-doc .item {\n    object-fit: none;\n    max-height: calc(100% - 37px);\n    background-color: var(--frostedwhite);\n}\n\n@media screen and (max-width: 1500px) {\n    .mediaSearch {\n        align-items: flex-start;\n    }\n}\n\n@media screen and (max-width: 1200px) {\n    .uploadMediaPopup .deleteIconImage {\n        top: 10px;\n    }\n\n    .gridIitem {\n        grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n        gap: 20px;\n    }\n}\n\n@media screen and (max-width: 991px) {\n    .popupContainer .popupAddFactor {\n        width: calc(100% - 30px);\n    }\n\n    .uploadMediaPopup .popup-overlay {\n        background-color: rgba(255, 255, 255, 1);\n    }\n\n    .uploadMediaPopup .grid-container.show-wrapper .register-wrapp .register-right {\n        display: none;\n    }\n\n    .uploadMediaPopup .grid-container.show-wrapper {\n        width: 100%;\n    }\n\n    .uploadMediaPopup .popupBlock {\n        width: calc(100dvw - 30px);\n        max-width: calc(100dvw - 30px);\n    }\n\n    .uploadMediaPopup .grid-container {\n        width: 100%;\n        display: block;\n        padding: 24px;\n        max-height: calc(100dvh - 216px);\n    }\n\n    .uploadMediaPopup .file-wrapper {\n        width: 100%;\n        border-left: none;\n        border-top: 1px solid var(--lightgrey);\n        height: auto;\n        min-height: unset;\n    }\n\n    .uploadMediaPopup .file-wrapper .file {\n        display: none;\n    }\n\n    .uploadMediaPopup .file-wrapper .modalActions {\n        display: none;\n    }\n\n    .uploadMediaPopup .popupBlock .popupBlock-wrapper .popupBlock-inner {\n        height: auto;\n        border: 1px solid var(--lightgrey);\n        border-radius: 8px;\n    }\n\n    .uploadMediaPopup .fileUploadBox .uploadFileBlock {\n        width: 100%;\n        border: none;\n        box-shadow: none;\n        height: calc(100dvh - 175px);\n    }\n\n    .popupBlock-wrapper {\n        padding: 15px;\n        margin: 5px;\n    }\n\n    .popupBlockPlan:has(.popupChange) .popupBlock-inner,\n    .popupBlockPlan .popupChange {\n        width: 100%;\n    }\n}\n\n@media screen and (max-width: 980px) {\n    .mediaSearchTop .mediaSearchInput input {\n        right: 0px;\n        width: calc(100% - 20px);\n    }\n\n    .mediaSearchTop .mediaSearchInput img {\n        position: absolute;\n        left: 15px;\n        top: 13px;\n    }\n}\n\n@media screen and (max-width: 840px) {\n    .mediaSearch {\n        margin-top: 0px;\n    }\n\n    .mediaSearchTop .mediaSearchInput input {\n        right: 0px;\n    }\n\n    .mediaSearchTop .mediaSearchInput img {\n        left: 15px;\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .mediaSearch {\n        display: flex;\n    }\n\n    .mediaSearchTop .mediaSearchInput{\n        width: calc(100% - 50px);\n    }\n\n    .mediaSearchTop .mediaSearchInput input {\n        right: 0px;\n    }\n\n    .mediaSearchTop .mediaSearchInput img {\n        left: 15px;\n    }\n\n    .gridIitem {\n        grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));\n    }\n}\n\n@media screen and (max-width: 767px) {\n    .uploadMediaPopup .popupBlock .popupContent .popupTitle {\n        padding: 15px 15px 0;\n    }\n\n    .uploadMediaPopup .tabTitle {\n        padding: 0 15px;\n    }\n\n    .uploadMediaPopup .grid-container {\n        padding: 15px;\n        height: auto;\n    }\n\n    .uploadMediaPopup .fileUploadBox .uploadFileBlock {\n        height: auto;\n        min-height: 361px;\n    }\n\n    .uploadMediaPopup .mediaSearch {\n        margin-bottom: 15px;\n    }\n\n    .uploadMediaPopup .file-wrapper {\n        border-top: none;\n    }\n}\n\n@media screen and (max-width: 576px) {\n    .gridIitem {\n        grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n    }\n}\n\n@media screen and (max-width: 490px) {\n    .fileUploadCover_Img {\n        padding-top: 0 !important;\n    }\n}\n\n@media screen and (max-width: 480px) {\n    .mediaSearch {\n        width: 100%;\n    }\n}\n\n@media screen and (max-width: 400px) {\n    .popupBlock-wrapper {\n        padding: 10px;\n    }\n}\n\n@media screen and (max-width: 390px) {\n    .fileUploadCover_Img {\n        padding-top: 15px;\n    }\n}\n\n@media screen and (max-width: 360px) {\n    .gridIitem {\n        grid-template-columns: repeat(auto-fit, minmax(110px, 1fr));\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
